(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
(function(){
 function init(root){
  root.querySelectorAll('.mp-fast-hero').forEach(function(hero){
   if(hero.dataset.mpReady)return;hero.dataset.mpReady='true';
   var video=hero.querySelector('video[data-mp-src]'),poster=hero.querySelector('.mp-hero-poster');
   if(!video||!poster)return;
   if(window.matchMedia('(prefers-reduced-motion: reduce)').matches||(navigator.connection&&navigator.connection.saveData))return;
   function start(){
    if(!hero.isConnected)return;
    requestAnimationFrame(function(){requestAnimationFrame(function(){
     setTimeout(function(){
      if(!hero.isConnected)return;
      video.addEventListener('playing',function(){hero.classList.add('mp-video-playing')},{once:true});
      video.src=video.dataset.mpSrc;video.muted=true;
      var playing=video.play();if(playing)playing.catch(function(){});
     },250);
    });});
   }
   if(poster.complete&&poster.naturalWidth)start();else poster.addEventListener('load',start,{once:true});
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});else init(document);
 document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-latest-reviews"] && !Shopify.designMode) return;
  try {
    
function setupReviews(root){root.querySelectorAll('.mp-reviews').forEach(section=>{if(section.dataset.initialized)return;section.dataset.initialized='true';const track=section.querySelector('.mp-reviews__track');const buttons=section.querySelectorAll('[data-review-direction]');const update=()=>{buttons.forEach(button=>{button.disabled=Number(button.dataset.reviewDirection)<0?track.scrollLeft<=2:track.scrollLeft+track.clientWidth>=track.scrollWidth-2})};buttons.forEach(button=>button.addEventListener('click',()=>{const card=track.querySelector('.mp-review');track.scrollBy({left:Number(button.dataset.reviewDirection)*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}));track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);update()})}setupReviews(document);document.addEventListener('shopify:section:load',event=>setupReviews(event.target));

  } catch(e) { console.error(e); }
})();
})();
